module.exports = __webpack_public_path__ + "img/file-code.f63feb31.svg";